//prod: 'https://taste-backoffice.ubiwhere.com'
//qa: 'https://taste.who-knows.pt'
let server;

switch (process.env.TASTE_ENV) {
  case "development":
    server = "https://backoffice.tasteportugal.com";
    break;
  case "production":
    server = "https://backoffice.tasteportugal.com";
    break;
  case "qa":
    server = "https://backoffice.tasteportugal.com";
    break;
  default:
    server = "https://backoffice.tasteportugal.com";
    break;
}

export const SERVER = server;



// WEBPACK FOOTER //
// ./src/config.js